<div class="header-container">
  <div class="header-left-container">
    <div routerLink="/" class="header-logo" [class.header-logo-orange]="lightBackground"></div>
  </div>
  <div class="header-right-container" *ngIf="!hideNav">
    <app-button routerLink="/svetovalnica" class="header-button header-button-right-offset" text="Svetovalnica"></app-button>
<!--    <app-button (click)="onLoginClick()" class="header-button" text="Prijava"></app-button>-->
  </div>
</div>
